import { ValidatorFn } from '@angular/forms';

export const requiredTextValidator: (message: string) => ValidatorFn = (
  message
) => {
  return (control) => {
    const value = control.value;
    return !value ? { required: message } : null;
  };
};
